import script from "./CustomerAuditsView.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerAuditsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__